// Amrita Naturals — Variant Image Switcher
// Works on all products automatically
// Add to: assets/variant-image-switcher.js
// Then include in theme.liquid before </body>

(function () {
  function initVariantSwitcher() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    var variantSelect = form.querySelector('select[name="id"]');
    var variantRadios = form.querySelectorAll('input[name="id"]');
    var variantButtons = form.querySelectorAll('[data-variant-id]');

    // Main image selectors — covers Dawn, Debut, and most themes
    var mainImageSelectors = [
      '.product__media img',
      '.product-single__photo img',
      '.product-featured-img',
      '[data-product-featured-image]',
      '.product__main-photos img',
      'img.product-featured-img',
      '.product-image-main img',
      '#ProductPhotoImg',
    ];

    function getMainImage() {
      for (var i = 0; i < mainImageSelectors.length; i++) {
        var el = document.querySelector(mainImageSelectors[i]);
        if (el) return el;
      }
      return null;
    }

    function getVariantData() {
      // Shopify injects variant data as JSON in the page
      var scriptTag = document.querySelector('[data-product-json]') ||
                      document.getElementById('ProductJson') ||
                      document.querySelector('script[type="application/json"][data-product-json]');
      if (scriptTag) {
        try { return JSON.parse(scriptTag.textContent); } catch (e) {}
      }

      // Try window.ShopifyAnalytics
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        return window.ShopifyAnalytics.meta.product;
      }

      // Try meta tag
      var metaTag = document.querySelector('meta[itemprop="offers"]');
      if (metaTag) {
        try {
          var productData = JSON.parse(document.querySelector('script[type="application/ld+json"]').textContent);
          return productData;
        } catch (e) {}
      }
      return null;
    }

    function switchImage(variantId) {
      var productData = getVariantData();
      if (!productData || !productData.variants) return;

      var selectedVariant = productData.variants.find(function (v) {
        return String(v.id) === String(variantId);
      });

      if (!selectedVariant || !selectedVariant.featured_image) return;

      var newImageUrl = selectedVariant.featured_image.src;
      if (!newImageUrl) return;

      // Clean URL — remove size suffix so we can set our own
      newImageUrl = newImageUrl.replace(/(_\d+x\d*|_\d*x\d+)(\.[a-z]+)(\?.*)?$/i, '$2$3');

      var mainImg = getMainImage();
      if (mainImg) {
        mainImg.src = newImageUrl.replace(/(\.[a-z]+)(\?.*)?$/i, '_800x800$1$2');
        mainImg.srcset = '';

        // Also update any srcset images
        var picture = mainImg.closest('picture');
        if (picture) {
          picture.querySelectorAll('source').forEach(function (source) {
            source.srcset = '';
          });
        }
      }

      // Update thumbnails — highlight matching thumb
      var thumbs = document.querySelectorAll('.product__media-list img, .product-single__thumbnails img, .thumbnail img, [data-thumbnail-id]');
      thumbs.forEach(function (thumb) {
        if (thumb.src && thumb.src.includes(selectedVariant.featured_image.src.split('?')[0].split('_')[0])) {
          thumb.parentElement && thumb.parentElement.click && thumb.parentElement.click();
        }
      });
    }

    // Listen to SELECT change (older themes)
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        switchImage(this.value);
      });
    }

    // Listen to RADIO change
    variantRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        switchImage(this.value);
      });
    });

    // Listen to data-variant-id buttons (newer themes + custom themes)
    variantButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchImage(this.getAttribute('data-variant-id'));
      });
    });

    // Listen to Shopify variant:changed custom event (Dawn theme)
    document.addEventListener('variant:changed', function (e) {
      if (e.detail && e.detail.variant) {
        switchImage(e.detail.variant.id);
      }
    });

    // Dawn theme specific
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        switchImage(e.target.value);
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSwitcher);
  } else {
    initVariantSwitcher();
  }
})();
